import { render, staticRenderFns } from "./ItemCustomization.vue?vue&type=template&id=d8d2cad6&"
import script from "./ItemCustomization.vue?vue&type=script&lang=ts&"
export * from "./ItemCustomization.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports